declare const __nominal__type: unique symbol;

export type Nominal<Type, Identifier> = Type & {
  readonly [__nominal__type]: Identifier;
};

export type TypedUrl<T> = string & { readonly __response?: T };

export type ApiError = { message: string; status: number };

export type OkResponse = { ok: true };

// Brand a plain string URL with its expected response type. Erased at runtime.
export function url<T>(s: string): TypedUrl<T> {
  return s;
}
